import React from 'react';
import { Select } from 'antd';

const LabeledDropdown = ({
  label,
  options = [],
  placeholder = "Select an option",
  value,
  onChange,
  className = ""
}) => {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-xs text-gray-600 ml-[8px]">
          {label}
        </label>
      )}
      <Select
        showSearch
        popupClassName="rounded-md text-xs"
        className={`w-full h-10 text-xs ${className}`}
        placeholder={placeholder}
        optionFilterProp="label"
        value={value || undefined}
        onChange={onChange}
        onSearch={(value) => console.log('search:', value)}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        options={options}
      />
    </div>
  );
};

export default LabeledDropdown;
